export const ExternalLinks = (function () {
	'use strict';

	function init() {
		$('a[href^="mailto:"]').each( function() {
			$(this).attr('target', '_blank');
		});

		events();
	}

	function events() {

		$('body').on('click', 'a', function (event) {
			if (
				// blog.amsoil.com
				// this.href.indexOf(window.location.host) < 0 &&
				this.href.indexOf('https://www.amsoil.com') !== 0 &&
				this.href.indexOf('https://amsoil.com') !== 0 &&
				this.href.indexOf('https://blog.amsoil.com') !== 0 &&
				this.href.indexOf('https://community.amsoil.com') !== 0 &&
				!wp
			) {
				event.preventDefault();
				event.stopPropagation();
				window.open(this.href, '_blank');
			}
		});

		$('a[href^="#copy"]').on('click', function(e) {
			e.preventDefault();

			var dummy = document.createElement('input'),
		    text = window.location.href;

			document.body.appendChild(dummy);
			dummy.value = text;
			dummy.select();
			document.execCommand('copy');
			document.body.removeChild(dummy);

			$(this).addClass('copied');

			

		});

	}

	return {
		init: init,
	};
})();
